import styled, {css} from 'styled-components';
import {FlexBox, Colors, FInter, ExternalLink} from '@brg/ui';
import { LayoutConst } from 'core/modules';

export const ProjectDesignerWrapper = styled(FlexBox)<{ isBlackTheme?: boolean, isDafesMapPopUp?: boolean, isPresentation?: boolean, isHSEDesign?: boolean }>`
    width: 100%;
    font-family: inherit;
    font-size: 13px;
    line-height: 16px;
    color: ${({ isBlackTheme, isPresentation }) => isBlackTheme ? Colors.geoWhite100 : 'inherit'} ;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: ${(p) => p.theme.projectView.authorWeight};
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap; 
    // max-width: ${({isPresentation}) => isPresentation ? 320 : 180}px; 
    overflow: hidden;
    flex: 1;
    &:hover {
        color: ${(p) => p.theme.projectView.authorColorHover};
    }

    // @media(max-width: ${LayoutConst.screen.mac13}px) {
    //   max-width: ${({isPresentation}) => isPresentation ? 320 : 138}px; 
    // }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 11px;
      line-height: 13px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      font-size: 13px;
      line-height: 16px;
    }
    // @media(max-width: ${LayoutConst.screen.s - 1}px) {
    //   max-width: 138px; 
    // }
`;

export const LinkWrapper = styled(ExternalLink)<{ isBlackTheme?: boolean }>`
  display: inline;
  &, &:active, & :visited {
    color: ${({ isBlackTheme, isPresentation }) => isBlackTheme ? Colors.geoWhite100 : 'inherit'};
  }
`

export const BlackFlatTooltip = styled(FlexBox)<{hidden?: boolean}>`
    background: ${(p) => p.theme.multipleAuthors.bg};
    border-radius: 3px;
    min-width: 272px;
    overflow: hidden;
    box-shadow: ${(p) => p.theme.multipleAuthors.shadow};
    display: ${(p) => p?.hidden ? "none" : "block"};
  
   
`;

export const DesignersTooltipItem = styled.span`
    width: 100%;
    transition: color 0.2s;
    cursor: pointer;
    color: ${(p) => p.theme.multipleAuthors.color} !important;
    &:hover {
        color: ${(p) => p.theme.multipleAuthors.colorHover} !important;
        text-decoration: none;

        > div {
          background-color: ${(p) => p.theme.multipleAuthors.bgHover} !important;
        }
    }
`;

export const DesignersLikesText = styled(FInter.SmallTextFlex)`
  letter-spacing: -0.02em;
  font-weight: 400;
  font-size: 17px !important;
  line-height: 22px !important;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px !important;
    line-height: 20px !important;
  }
`

export const DesignerMultipleAuthors = styled(ProjectDesignerWrapper)<{active: boolean, big?: boolean, isDafesMapPopUp?: boolean, severalАuthors?: boolean, isMedia?: boolean }>`
  align-items: center;
  display: ${({severalАuthors}) => severalАuthors ? 'flex': 'block'};
  > svg {
    margin-top: 2px;
    transform: rotate(0deg);
    transition: all 0.2s;
  }

  ${({ isDafesMapPopUp }) => isDafesMapPopUp && css`

    &:hover {
      .multiple-authors {
        color: rgb(197, 198, 199) !important;
        &:hover {
          color: #909090 !important;
        }
      }
      svg {
        path {
          fill: #909090 !important;
        }
      }
    }
  `};
  
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    > svg {
      margin-top: 0;
    }

    font-size: ${p => p.big ? 13 : 11}px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 13px;
    color: #909090;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    svg {
      width: 10px;
      height: 6px;
    }
  }
  @media (max-width: ${LayoutConst.screen.md}px) {

    &:hover {
      color: ${({ isDafesMapPopUp, isMedia }) => isDafesMapPopUp || isMedia ? '#909090' : 'inherit'};
    }
    
    ${p => p.active && css`
      color: ${(p) => p.theme.multipleAuthors.colorHover};

      &:hover {
        color: ${(p) => p.theme.multipleAuthors.colorHover};
      }
      
      svg {
        transform: rotate(-180deg);
      }

      svg path {
          // fill: ${(p) => p.theme.projectView.authorColorHover};
        fill: ${(p) => p.theme.multipleAuthors.colorHover};
      }
    `};
  }
  @media (min-width: ${LayoutConst.screen.md}px) {

    &:hover {
        // color: ${(p) => p.theme.projectView.authorColorHover};
      color: ${Colors.geoWhite100};

      svg {
        transform: rotate(-180deg);
      }

      svg path {
          // fill: ${(p) => p.theme.projectView.authorColorHover};
        fill: ${Colors.geoWhite100};
      }
    }

  }
`;import styled, {css} from 'styled-components';
import {FlexBox, Colors, FInter, ExternalLink} from '@brg/ui';
import { LayoutConst } from 'core/modules';

export const ProjectDesignerWrapper = styled(FlexBox)<{ isBlackTheme?: boolean, isDafesMapPopUp?: boolean, isPresentation?: boolean, isHSEDesign?: boolean }>`
    width: 100%;
    font-family: inherit;
    font-size: 13px;
    line-height: 16px;
    color: ${({ isBlackTheme, isPresentation }) => isBlackTheme ? Colors.geoWhite100 : 'inherit'} ;
    cursor: pointer;
    transition: all 0.2s;
    font-weight: ${(p) => p.theme.projectView.authorWeight};
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap; 
    // max-width: ${({isPresentation}) => isPresentation ? 320 : 180}px; 
    overflow: hidden;
    flex: 1;
    &:hover {
        color: ${(p) => p.theme.projectView.authorColorHover};
    }

    // @media(max-width: ${LayoutConst.screen.mac13}px) {
    //   max-width: ${({isPresentation}) => isPresentation ? 320 : 138}px; 
    // }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: 11px;
      line-height: 13px;
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
      font-size: 13px;
      line-height: 16px;
    }
    // @media(max-width: ${LayoutConst.screen.s - 1}px) {
    //   max-width: 138px; 
    // }
`;

export const LinkWrapper = styled(ExternalLink)<{ isBlackTheme?: boolean }>`
  display: inline;
  &, &:active, & :visited {
    color: ${({ isBlackTheme, isPresentation }) => isBlackTheme ? Colors.geoWhite100 : 'inherit'};
  }
`

export const BlackFlatTooltip = styled(FlexBox)<{hidden?: boolean}>`
    background: ${(p) => p.theme.multipleAuthors.bg};
    border-radius: 3px;
    min-width: 272px;
    overflow: hidden;
    box-shadow: ${(p) => p.theme.multipleAuthors.shadow};
    display: ${(p) => p?.hidden ? "none" : "block"};
  
   
`;

export const DesignersTooltipItem = styled.span`
    width: 100%;
    transition: color 0.2s;
    cursor: pointer;
    color: ${(p) => p.theme.multipleAuthors.color} !important;
    &:hover {
        color: ${(p) => p.theme.multipleAuthors.colorHover} !important;
        text-decoration: none;

        > div {
          background-color: ${(p) => p.theme.multipleAuthors.bgHover} !important;
        }
    }
`;

export const DesignersLikesText = styled(FInter.SmallTextFlex)`
  letter-spacing: -0.02em;
  font-weight: 400;
  font-size: 17px !important;
  line-height: 22px !important;

  @media (max-width: ${LayoutConst.screen.mac13}px) {
    font-size: 15px !important;
    line-height: 20px !important;
  }
`

export const DesignerMultipleAuthors = styled(ProjectDesignerWrapper)<{active: boolean, big?: boolean, isDafesMapPopUp?: boolean, severalАuthors?: boolean, isMedia?: boolean }>`
  align-items: center;
  display: ${({severalАuthors}) => severalАuthors ? 'flex': 'block'};
  > svg {
    margin-top: 2px;
    transform: rotate(0deg);
    transition: all 0.2s;
  }

  ${({ isDafesMapPopUp }) => isDafesMapPopUp && css`

    &:hover {
      .multiple-authors {
        color: rgb(197, 198, 199) !important;
        &:hover {
          color: #909090 !important;
        }
      }
      svg {
        path {
          fill: #909090 !important;
        }
      }
    }
  `};
  
  @media (max-width: ${LayoutConst.screen.l_12}px) {
    > svg {
      margin-top: 0;
    }

    font-size: ${p => p.big ? 13 : 11}px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 13px;
    color: #909090;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    svg {
      width: 10px;
      height: 6px;
    }
  }
  @media (max-width: ${LayoutConst.screen.md}px) {

    &:hover {
      color: ${({ isDafesMapPopUp, isMedia }) => isDafesMapPopUp || isMedia ? '#909090' : 'inherit'};
    }
    
    ${p => p.active && css`
      color: ${(p) => p.theme.multipleAuthors.colorHover};

      &:hover {
        color: ${(p) => p.theme.multipleAuthors.colorHover};
      }
      
      svg {
        transform: rotate(-180deg);
      }

      svg path {
          // fill: ${(p) => p.theme.projectView.authorColorHover};
        fill: ${(p) => p.theme.multipleAuthors.colorHover};
      }
    `};
  }
  @media (min-width: ${LayoutConst.screen.md}px) {

    &:hover {
        // color: ${(p) => p.theme.projectView.authorColorHover};
      color: ${Colors.geoWhite100};

      svg {
        transform: rotate(-180deg);
      }

      svg path {
          // fill: ${(p) => p.theme.projectView.authorColorHover};
        fill: ${Colors.geoWhite100};
      }
    }

  }
`;